import { renderToast } from "../render/renderToast"

const openToast = data => {
  renderToast(data)
}

export default openToast
